
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  DbNull,
  JsonNull,
  AnyNull,
  NullTypes,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 7.10.0
 * Query Engine version: 0edf323efd1d98336f3f0a68684b56f689b900d3
 */
Prisma.prismaVersion = {
  client: "7.10.0",
  engine: "0edf323efd1d98336f3f0a68684b56f689b900d3"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = DbNull
Prisma.JsonNull = JsonNull
Prisma.AnyNull = AnyNull

Prisma.NullTypes = NullTypes



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.CityZipcodeCacheScalarFieldEnum = {
  id: 'id',
  city: 'city',
  zipcode: 'zipcode',
  weight: 'weight',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FeatureFlagScalarFieldEnum = {
  id: 'id',
  key: 'key',
  description: 'description',
  enabled: 'enabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FeatureFlagTargetScalarFieldEnum = {
  id: 'id',
  featureFlagId: 'featureFlagId',
  boothId: 'boothId',
  enabled: 'enabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CvTemplateConfigScalarFieldEnum = {
  id: 'id',
  enabled: 'enabled',
  featured: 'featured',
  position: 'position',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy'
};

exports.Prisma.SimulationScriptScalarFieldEnum = {
  id: 'id',
  name: 'name',
  role: 'role',
  locale: 'locale',
  persona: 'persona',
  enabled: 'enabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SimulationPreparedAnswerScalarFieldEnum = {
  id: 'id',
  scriptId: 'scriptId',
  category: 'category',
  questionPattern: 'questionPattern',
  answer: 'answer',
  createdAt: 'createdAt'
};

exports.Prisma.LocaleScalarFieldEnum = {
  codeLong: 'codeLong',
  codeShort: 'codeShort',
  name: 'name',
  elevenLabsVoiceId: 'elevenLabsVoiceId',
  enabled: 'enabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  codeI18n: 'codeI18n',
  webTranslations: 'webTranslations',
  boTranslations: 'boTranslations',
  gradiumVoiceId: 'gradiumVoiceId',
  ttsSourcePriority: 'ttsSourcePriority',
  sttSourcePriority: 'sttSourcePriority',
  llmSourcePriority: 'llmSourcePriority'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  image: 'image',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  phoneNumber: 'phoneNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  acceptedCGU: 'acceptedCGU',
  cguId: 'cguId',
  isAdmin: 'isAdmin',
  localeId: 'localeId',
  phoneNumberVerified: 'phoneNumberVerified',
  anonymizedAt: 'anonymizedAt',
  archivedAt: 'archivedAt',
  emailVerified: 'emailVerified',
  preferEmailNotification: 'preferEmailNotification',
  city: 'city',
  zipcode: 'zipcode'
};

exports.Prisma.CGUScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  content: 'content',
  localeId: 'localeId'
};

exports.Prisma.InterviewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  status: 'status',
  paymentIntentId: 'paymentIntentId',
  localeId: 'localeId',
  boothId: 'boothId'
};

exports.Prisma.CVScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  location: 'location',
  jobTitle: 'jobTitle',
  pictureBase64: 'pictureBase64',
  summary: 'summary',
  competences: 'competences',
  interviewId: 'interviewId',
  hasDriverLicense: 'hasDriverLicense',
  hobbiesAndInterests: 'hobbiesAndInterests',
  postalCode: 'postalCode',
  mobilityRadius: 'mobilityRadius',
  mobilityRange: 'mobilityRange',
  localeId: 'localeId',
  templateParams: 'templateParams',
  template: 'template',
  deletedAt: 'deletedAt',
  status: 'status',
  validatedAt: 'validatedAt',
  driverLicenseTypes: 'driverLicenseTypes',
  isMobile: 'isMobile',
  openToTraining: 'openToTraining',
  isReconversion: 'isReconversion',
  complementaryMentions: 'complementaryMentions',
  hasRQTH: 'hasRQTH',
  gender: 'gender',
  strengths: 'strengths',
  preferedTasks: 'preferedTasks',
  notPreferedTasks: 'notPreferedTasks'
};

exports.Prisma.ExperienceScalarFieldEnum = {
  id: 'id',
  company: 'company',
  location: 'location',
  title: 'title',
  missions: 'missions',
  startDate: 'startDate',
  endDate: 'endDate',
  cvId: 'cvId'
};

exports.Prisma.PersonalExperienceScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  location: 'location',
  startDate: 'startDate',
  endDate: 'endDate',
  cvId: 'cvId'
};

exports.Prisma.LanguageScalarFieldEnum = {
  id: 'id',
  language: 'language',
  level: 'level',
  cvId: 'cvId'
};

exports.Prisma.EducationScalarFieldEnum = {
  id: 'id',
  school: 'school',
  degree: 'degree',
  location: 'location',
  cvId: 'cvId',
  acquiredSkills: 'acquiredSkills',
  degreeObtainedAt: 'degreeObtainedAt',
  degreeStartedAt: 'degreeStartedAt',
  name: 'name'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  expiresAt: 'expiresAt',
  token: 'token',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  userId: 'userId',
  impersonatedById: 'impersonatedById'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  providerId: 'providerId',
  userId: 'userId',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  idToken: 'idToken',
  accessTokenExpiresAt: 'accessTokenExpiresAt',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  scope: 'scope',
  password: 'password',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.VerificationScalarFieldEnum = {
  id: 'id',
  identifier: 'identifier',
  value: 'value',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentIntentScalarFieldEnum = {
  id: 'id',
  stripePaymentIntentId: 'stripePaymentIntentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BoothScalarFieldEnum = {
  id: 'id',
  label: 'label',
  machineUid: 'machineUid',
  terminalId: 'terminalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  platformType: 'platformType',
  jobsources: 'jobsources',
  address: 'address',
  lat: 'lat',
  lon: 'lon',
  ip: 'ip',
  defaultLocaleId: 'defaultLocaleId',
  defaultTranslationLocaleId: 'defaultTranslationLocaleId',
  interfacePreselected: 'interfacePreselected',
  otpMode: 'otpMode'
};

exports.Prisma.BoothStatusScalarFieldEnum = {
  id: 'id',
  boothId: 'boothId',
  data: 'data',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BoothExclusionScalarFieldEnum = {
  term: 'term',
  boothId: 'boothId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BoothOrganizationScalarFieldEnum = {
  boothId: 'boothId',
  organizationId: 'organizationId',
  createdAt: 'createdAt'
};

exports.Prisma.BoothJobExclusionScalarFieldEnum = {
  boothId: 'boothId',
  jobId: 'jobId',
  createdAt: 'createdAt'
};

exports.Prisma.ConversationSnapshotScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  interviewId: 'interviewId',
  role: 'role',
  conversation: 'conversation',
  metadata: 'metadata'
};

exports.Prisma.EventSessionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  boothId: 'boothId',
  platformType: 'platformType',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  language: 'language'
};

exports.Prisma.EventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  eventSessionId: 'eventSessionId',
  userId: 'userId',
  boothId: 'boothId',
  platformType: 'platformType',
  data: 'data'
};

exports.Prisma.JobApplicationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  cvId: 'cvId',
  jobId: 'jobId',
  jobTitle: 'jobTitle',
  companyName: 'companyName',
  appliedAt: 'appliedAt',
  status: 'status',
  notes: 'notes',
  jobSource: 'jobSource'
};

exports.Prisma.AtlantisSyncRunScalarFieldEnum = {
  id: 'id',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  status: 'status',
  triggeredBy: 'triggeredBy',
  total: 'total',
  published: 'published',
  errors: 'errors',
  lastPolledAt: 'lastPolledAt',
  pollCount: 'pollCount'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  type: 'type',
  title: 'title',
  message: 'message',
  data: 'data',
  readAt: 'readAt'
};

exports.Prisma.ActivityLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  type: 'type',
  title: 'title',
  icon: 'icon',
  data: 'data'
};

exports.Prisma.Spatial_ref_sysScalarFieldEnum = {
  srid: 'srid',
  auth_name: 'auth_name',
  auth_srid: 'auth_srid',
  srtext: 'srtext',
  proj4text: 'proj4text'
};

exports.Prisma.BoothFeedbackScalarFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  boothId: 'boothId',
  sessionId: 'sessionId',
  category: 'category',
  comment: 'comment',
  notionTicketUrl: 'notionTicketUrl',
  responsibleName: 'responsibleName',
  ticketComment: 'ticketComment',
  locale: 'locale',
  source: 'source',
  flowStep: 'flowStep',
  lastMessage: 'lastMessage',
  appVersion: 'appVersion',
  userEmail: 'userEmail',
  userPhone: 'userPhone',
  healthSnapshot: 'healthSnapshot',
  status: 'status',
  resolvedAt: 'resolvedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BoothFeedbackAudioScalarFieldEnum = {
  id: 'id',
  feedbackId: 'feedbackId',
  url: 'url',
  durationMs: 'durationMs',
  position: 'position',
  transcript: 'transcript',
  audioData: 'audioData',
  createdAt: 'createdAt'
};

exports.Prisma.BoothFeedbackCommentScalarFieldEnum = {
  id: 'id',
  feedbackId: 'feedbackId',
  authorId: 'authorId',
  authorName: 'authorName',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BoothFeedbackJournalScalarFieldEnum = {
  id: 'id',
  feedbackId: 'feedbackId',
  authorId: 'authorId',
  authorName: 'authorName',
  action: 'action',
  fromStatus: 'fromStatus',
  toStatus: 'toStatus',
  createdAt: 'createdAt'
};

exports.Prisma.WebRegionConfigScalarFieldEnum = {
  countryCode: 'countryCode',
  label: 'label',
  defaultLocaleId: 'defaultLocaleId',
  defaultTranslationLocaleId: 'defaultTranslationLocaleId',
  interfacePreselected: 'interfacePreselected',
  enabled: 'enabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WorldCityScalarFieldEnum = {
  geonameId: 'geonameId',
  countryCode: 'countryCode',
  name: 'name',
  nameAscii: 'nameAscii',
  searchName: 'searchName',
  nameEn: 'nameEn',
  searchNameEn: 'searchNameEn',
  admin1: 'admin1',
  lat: 'lat',
  lon: 'lon',
  population: 'population',
  sourceModDate: 'sourceModDate',
  updatedAt: 'updatedAt'
};

exports.Prisma.WorldCountryScalarFieldEnum = {
  code: 'code',
  nameEn: 'nameEn'
};

exports.Prisma.WorldCityAltNameScalarFieldEnum = {
  geonameId: 'geonameId',
  lang: 'lang',
  name: 'name',
  searchName: 'searchName'
};

exports.Prisma.WorldPostalCodeScalarFieldEnum = {
  id: 'id',
  countryCode: 'countryCode',
  postalCode: 'postalCode',
  placeName: 'placeName',
  searchName: 'searchName',
  adminName1: 'adminName1',
  adminName2: 'adminName2',
  adminName3: 'adminName3',
  syncedAt: 'syncedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.TTSSourceEnum = exports.$Enums.TTSSourceEnum = {
  GRADIUM: 'GRADIUM',
  ELEVEN_LABS: 'ELEVEN_LABS'
};

exports.STTSourceEnum = exports.$Enums.STTSourceEnum = {
  GLADIA: 'GLADIA',
  WHISPER: 'WHISPER'
};

exports.LLMSourceEnum = exports.$Enums.LLMSourceEnum = {
  OPENAI: 'OPENAI',
  MISTRAL: 'MISTRAL'
};

exports.InterviewStatus = exports.$Enums.InterviewStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  CONNECTION_LOST: 'CONNECTION_LOST',
  CANCELLED: 'CANCELLED'
};

exports.CVStatus = exports.$Enums.CVStatus = {
  VALIDATED: 'VALIDATED',
  DELETED: 'DELETED'
};

exports.BoothOtpMode = exports.$Enums.BoothOtpMode = {
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  DISABLED: 'DISABLED'
};

exports.ConversationMessageRole = exports.$Enums.ConversationMessageRole = {
  user: 'user',
  assistant: 'assistant'
};

exports.JobApplicationStatus = exports.$Enums.JobApplicationStatus = {
  SENT: 'SENT',
  VIEWED: 'VIEWED',
  REJECTED: 'REJECTED',
  INTERVIEW: 'INTERVIEW',
  ACCEPTED: 'ACCEPTED',
  NO_CONTACT: 'NO_CONTACT'
};

exports.AtlantisSyncStatus = exports.$Enums.AtlantisSyncStatus = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
};

exports.NotificationType = exports.$Enums.NotificationType = {
  APPLICATION_STATUS: 'APPLICATION_STATUS',
  APPLICATION_RECEIVED: 'APPLICATION_RECEIVED',
  INTERVIEW_REMINDER: 'INTERVIEW_REMINDER',
  JOB_MATCH: 'JOB_MATCH',
  SYSTEM: 'SYSTEM'
};

exports.ActivityType = exports.$Enums.ActivityType = {
  CV_CREATED: 'CV_CREATED',
  CV_UPDATED: 'CV_UPDATED',
  APPLICATION_SENT: 'APPLICATION_SENT',
  STATUS_CHANGED: 'STATUS_CHANGED',
  INTERVIEW_STARTED: 'INTERVIEW_STARTED',
  PROFILE_UPDATED: 'PROFILE_UPDATED'
};

exports.BoothFeedbackCategory = exports.$Enums.BoothFeedbackCategory = {
  MICROPHONE: 'MICROPHONE',
  CAMERA: 'CAMERA',
  SOUND_OUTPUT: 'SOUND_OUTPUT',
  TOUCHSCREEN: 'TOUCHSCREEN',
  APP_BLOCKED: 'APP_BLOCKED',
  CONNECTIVITY: 'CONNECTIVITY',
  COMFORT: 'COMFORT',
  CLEANLINESS: 'CLEANLINESS',
  OTHER: 'OTHER'
};

exports.BoothFeedbackSource = exports.$Enums.BoothFeedbackSource = {
  KIOSK: 'KIOSK',
  ANDROID_APP: 'ANDROID_APP',
  WEB: 'WEB'
};

exports.BoothFeedbackStatus = exports.$Enums.BoothFeedbackStatus = {
  NEW: 'NEW',
  TRIAGED: 'TRIAGED',
  IN_PROGRESS: 'IN_PROGRESS',
  RESOLVED: 'RESOLVED',
  DISMISSED: 'DISMISSED',
  SEEN: 'SEEN'
};

exports.BoothFeedbackJournalAction = exports.$Enums.BoothFeedbackJournalAction = {
  OPENED: 'OPENED',
  STATUS_CHANGED: 'STATUS_CHANGED',
  COMMENT_ADDED: 'COMMENT_ADDED',
  COMMENT_UPDATED: 'COMMENT_UPDATED',
  FOLLOW_UP_UPDATED: 'FOLLOW_UP_UPDATED'
};

exports.Prisma.ModelName = {
  CityZipcodeCache: 'CityZipcodeCache',
  FeatureFlag: 'FeatureFlag',
  FeatureFlagTarget: 'FeatureFlagTarget',
  CvTemplateConfig: 'CvTemplateConfig',
  SimulationScript: 'SimulationScript',
  SimulationPreparedAnswer: 'SimulationPreparedAnswer',
  Locale: 'Locale',
  User: 'User',
  CGU: 'CGU',
  Interview: 'Interview',
  CV: 'CV',
  Experience: 'Experience',
  PersonalExperience: 'PersonalExperience',
  Language: 'Language',
  Education: 'Education',
  Session: 'Session',
  Account: 'Account',
  Verification: 'Verification',
  PaymentIntent: 'PaymentIntent',
  Booth: 'Booth',
  BoothStatus: 'BoothStatus',
  BoothExclusion: 'BoothExclusion',
  BoothOrganization: 'BoothOrganization',
  BoothJobExclusion: 'BoothJobExclusion',
  ConversationSnapshot: 'ConversationSnapshot',
  EventSession: 'EventSession',
  Event: 'Event',
  JobApplication: 'JobApplication',
  AtlantisSyncRun: 'AtlantisSyncRun',
  Notification: 'Notification',
  ActivityLog: 'ActivityLog',
  spatial_ref_sys: 'spatial_ref_sys',
  BoothFeedback: 'BoothFeedback',
  BoothFeedbackAudio: 'BoothFeedbackAudio',
  BoothFeedbackComment: 'BoothFeedbackComment',
  BoothFeedbackJournal: 'BoothFeedbackJournal',
  WebRegionConfig: 'WebRegionConfig',
  WorldCity: 'WorldCity',
  WorldCountry: 'WorldCountry',
  WorldCityAltName: 'WorldCityAltName',
  WorldPostalCode: 'WorldPostalCode'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
